import { render } from "./EthereumIconGrey.vue?vue&type=template&id=3d97f357"
const script = {}
script.render = render

export default script